import { ChangeEvent, FC } from 'react';

import { RadioGroup, Radio, Label, Box, RadioGroupDirection } from '@base-app';
import { DevToolsContainer } from '@dev-tools';
import { getParticipantRecruitmentLayouts } from '@/modules/core/utils/partnerType';

import { LayoutSwitcherProps } from './LayoutSwitcher.types';

const layouts = getParticipantRecruitmentLayouts();

const LayoutSwitcher: FC<LayoutSwitcherProps> = ({ defaultValue, handlerOnChange }) => {
  const handleChangePartner = (event: ChangeEvent<HTMLInputElement>): void => {
    const { name, value } = event.target;

    handlerOnChange({ partner: value, layout: name });
  };

  return (
    <DevToolsContainer>
      <Label css={{ whiteSpace: 'nowrap' }}>{`Layout Switch`}</Label>
      <RadioGroup
        defaultValue={defaultValue}
        direction={RadioGroupDirection.COLUMN}
        id=""
        name=""
        onChange={handleChangePartner}
      >
        {layouts.map((layout, index) => (
          <Radio id={layout.id} key={index} value={layout.value} name={layout.layout}>
            <Box css={{ whiteSpace: 'nowrap' }}>{`${layout.value} (${layout.layout})`} </Box>
          </Radio>
        ))}
      </RadioGroup>
    </DevToolsContainer>
  );
};

export default LayoutSwitcher;
